module.exports = __webpack_public_path__ + "img/timelapse-video-asuka-poster.d2b6d9c.jpg";